var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:(`width:${_vm.realWidth};height:${_vm.realHeight};`),attrs:{"src":_vm.src,"fit":"cover","preview-src-list":[_vm.src]}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('svg-icon',{attrs:{"name":"image-load-fail"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }